import { Colors } from "@/enums/Colors";
import { Tabs, TabsProps, styled } from "@mui/material";

const StyledTabs = styled(Tabs)(() => ({
  width: "100%",
  borderBottom: `1px solid ${Colors.LIGHT_GRAY}`,
  "& .MuiTabs-indicator": {
    backgroundColor: `${Colors.ELEGANT_BLACK}`,
  },
  "& .MuiButtonBase-root": {
    textTransform: "none",
    minHeight: 0,
    "&.Mui-selected": {
      color: Colors.ELEGANT_BLACK,
    },
  },
}));

function CommonTabs(props: TabsProps) {
  return (
    <>
      <StyledTabs {...props}>{props.children}</StyledTabs>
    </>
  );
}

export default CommonTabs;
